// import { initializeApp } from "firebase/app";
// import { getMessaging } from "firebase/messaging";

// const apiKey =
//   process.env.REACT_APP_ENV === "production"
//     ? process.env.REACT_APP_FIREBASE_API_KEY_PROD
//     : process.env.REACT_APP_ENV === "staging"
//     ? process.env.REACT_APP_FIREBASE_API_KEY_STAGING
//     : process.env.REACT_APP_FIREBASE_API_KEY_LOCAL;

// const authDomain =
//   process.env.REACT_APP_ENV === "production"
//     ? process.env.REACT_APP_FIREBASE_AUTH_DOMAIN_PROD
//     : process.env.REACT_APP_ENV === "staging"
//     ? process.env.REACT_APP_FIREBASE_AUTH_DOMAIN_STAGING
//     : process.env.REACT_APP_FIREBASE_AUTH_DOMAIN_LOCAL;

// const databaseURL =
//   process.env.REACT_APP_ENV === "production"
//     ? process.env.REACT_APP_FIREBASE_DB_URL_PROD
//     : process.env.REACT_APP_ENV === "staging"
//     ? process.env.REACT_APP_FIREBASE_DB_URL_STAGING
//     : process.env.REACT_APP_FIREBASE_DB_URL_LOCAL;
// const projectId =
//   process.env.REACT_APP_ENV === "production"
//     ? process.env.REACT_APP_FIREBASE_PROJECTID_PROD
//     : process.env.REACT_APP_ENV === "staging"
//     ? process.env.REACT_APP_FIREBASE_PROJECTID_STAGING
//     : process.env.REACT_APP_FIREBASE_PROJECTID_LOCAL;
// const storageBucket =
//   process.env.REACT_APP_ENV === "production"
//     ? process.env.REACT_APP_FIREBASE_STORAGEBUCKET_PROD
//     : process.env.REACT_APP_ENV === "staging"
//     ? process.env.REACT_APP_FIREBASE_STORAGEBUCKET_STAGING
//     : process.env.REACT_APP_FIREBASE_STORAGEBUCKET_LOCAL;
// const messagingSenderId =
//   process.env.REACT_APP_ENV === "production"
//     ? process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID_PROD
//     : process.env.REACT_APP_ENV === "staging"
//     ? process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID_STAGING
//     : process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID_LOCAL;
// const appId =
//   process.env.REACT_APP_ENV === "production"
//     ? process.env.REACT_APP_FIREBASE_APP_ID_PROD
//     : process.env.REACT_APP_ENV === "staging"
//     ? process.env.REACT_APP_FIREBASE_APP_ID_STAGING
//     : process.env.REACT_APP_FIREBASE_APP_ID_LOCAL;
// const measurementId =
//   process.env.REACT_APP_ENV === "production"
//     ? process.env.REACT_APP_FIREBASE_MEASUREMENT_ID_PROD
//     : process.env.REACT_APP_ENV === "staging"
//     ? process.env.REACT_APP_FIREBASE_MEASUREMENT_ID_STAGING
//     : process.env.REACT_APP_FIREBASE_MEASUREMENT_ID_LOCAL;

// const firebaseConfig = {
//   apiKey,
//   authDomain,
//   databaseURL,
//   projectId,
//   storageBucket,
//   messagingSenderId,
//   appId,
//   measurementId,
// };

// const app = initializeApp(firebaseConfig);

// const messaging = getMessaging(app);

// export { messaging, firebaseConfig };


import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyD6x77VOMVQaQCGMlR2RW7V4Y8mtKpvYts",
  authDomain: "noblemarriageuat-7c6f0.firebaseapp.com",
  databaseURL: "noblemarriageuat-7c6f0.firebaseio.com",
  projectId: "noblemarriageuat-7c6f0",
  storageBucket: "noblemarriageuat-7c6f0.firebasestorage.app",
  messagingSenderId: "548023905489",
  appId: "1:548023905489:web:e501e237bb55ba5a4769f0",
  measurementId: "G-K1EXKJ00RG",
};

const app = initializeApp(firebaseConfig);

const messaging = getMessaging(app);

export { messaging, firebaseConfig };